import React, { useState, useRef } from 'react';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog'
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { helpHttp } from '../../helpers/helpHttp';
import { BASE_API, LABELTEXT, LABELTEXT_S } from '../../api/Globals';
import ScannerEntrega from '../../pages/entrega/barcode';
import { storage } from '../../helpers/storage';
// import useScanDetection from 'use-scan-detection';

const emptyArr = { serie: '' }

const RegistrarTableta = (
    {
        visible = false,
        onHide = () => { },
    }
) => {
    const tituloModal = "REGISTRO DE " + LABELTEXT.toUpperCase();

    const [tablet, setTablet] = useState(emptyArr);
    const [dataRegistro, setDataRegistro] = useState([]);
    const [loading1, setLoadig1] = useState(false)
    const [scannerDialog, setScannerDialog] = useState(false);
    const toast = useRef(null);

    // useScanDetection({
    //     onComplete: (code) => { setTablet({ ...tablet, serie: code }); console.log(code) },
    // })

    const listarTablet = (e) => {
        e.preventDefault();
        let bandera = false
        if (parseInt(process.env.REACT_APP_SISTEMA) === 1 && tablet.serie.length < 12) {
            bandera = true
        } else if (parseInt(process.env.REACT_APP_SISTEMA) === 2 && tablet.serie.length < 11) {
            bandera = true
        }
        if (bandera !== true) {
            helpHttp().post(`${BASE_API}Pip/spdObtenerFolioPrendaTIT`, {
                body: {
                    CodigoPrenda: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? tablet.serie.slice(0, 2) : "09",
                    CodigoTalla: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? tablet.serie.slice(2, 5) : "111",
                    Serie: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? tablet.serie.slice(5) : tablet.serie,
                    IdAlumno: -1
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.ITEMS.SerieEntregado === null) {
                    let arr = dataRegistro
                    if (dataRegistro.length === 0) {
                        let resTablet = tablet
                        resTablet = { ...resTablet, index: 1 }
                        setDataRegistro([resTablet])
                    } else {
                        var bandera = false
                        arr.forEach(item => { if (item.serie === tablet.serie) bandera = true });
                        if (!bandera) {
                            arr.push(tablet);
                            const res = arr.map((e, i) => {
                                let item = {
                                    ...e,
                                    index: i + 1
                                }
                                return item
                            })
                            setDataRegistro(res)
                        } else {
                            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `${LABELTEXT_S} registrada previamente.`, life: 3000 })
                        }
                    }
                } else {
                    toast.current.show({ severity: 'warn', summary: 'Aviso', detail: res.ITEMS.Mensaje, life: 3000 })
                }
                setTablet(emptyArr)
            })
        } else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Serie incompleta.', life: 3000 })
        }
    }

    const listarTabletQR = (serie) => {
        let bandera = false
        // console.log(serie.length, serie)
        if (parseInt(process.env.REACT_APP_SISTEMA) === 1 && serie.length < 12) {
            bandera = true
        } else if (parseInt(process.env.REACT_APP_SISTEMA) === 2 && serie.length < 11) {
            bandera = true
        }
        if (bandera !== true) {
            helpHttp().post(`${BASE_API}Pip/spdObtenerFolioPrendaTIT`, {
                body: {
                    CodigoPrenda: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? serie.slice(0, 2) : "09",
                    CodigoTalla: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? serie.slice(2, 5) : "111",
                    Serie: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? serie.slice(5) : serie,
                    IdAlumno: -1
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.ITEMS.SerieEntregado === null) {
                    let arr = dataRegistro
                    if (dataRegistro.length === 0) {
                        let resTablet = {serie: serie}
                        resTablet = { ...resTablet, index: 1 }
                        setDataRegistro([resTablet])
                    } else {
                        var bandera = false
                        arr.forEach(item => { if (item.serie === serie) bandera = true });
                        if (!bandera) {
                            arr.push({serie: serie});
                            const res = arr.map((e, i) => {
                                let item = {
                                    ...e,
                                    index: i + 1
                                }
                                return item
                            })
                            setDataRegistro(res)
                        } else {
                            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: `${LABELTEXT_S} registrada previamente.`, life: 3000 })
                        }
                    }
                } else {
                    toast.current.show({ severity: 'warn', summary: 'Aviso', detail: res.ITEMS.Mensaje, life: 3000 })
                }
                setTablet(emptyArr)
            })
        } else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Serie incompleta.', life: 3000 })
        }
    }

    const guardarTablet = () => {
        const url = (`${BASE_API}Tablets/postspdAlmAltaTablet`)
        if (dataRegistro.length !== 0) {
            setLoadig1(true)
            const Tabla = dataRegistro.map(e => {
                let item = {
                    codigoPrenda: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? e.serie.slice(0, 2) : "09",
                    codigoTalla: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? e.serie.slice(2, 5) : "111",
                    serie: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? e.serie.slice(5) : e.serie
                }
                return item
            })

            // console.log(Tabla)
            helpHttp().post(url, {
                body: {
                    opcion: "D",
                    listaTablets: Tabla,
                    tipo: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? "Uniformes" : "Tablets",
                    idEstatus: 2,  //Se manda en 1 por ser alta
                    idUsuario: storage.get('id'),
                    NotificaciondeEjecucion: ""
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                // console.log(res)
                if (res.SUCCES !== false) {
                    setLoadig1(false)
                    onHideDialog();
                    // setMensajeEjecucion(JSON.parse(res.ITEMS.NotificacionEjecucion))
                    // setMensajeDialog(true)
                }
            })
        } else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Lista vacía, favor de escanear o de teclear la serie. En caso de teclear, presionar enter para completar el registro.', life: 5000 })
        }
    }

    const tabletDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" disabled={loading1} className="p-button-outlined" onClick={() => onHideDialog()} />
            <Button label="Guardar" icon="pi pi-check" loading={loading1} className="p-button" onClick={() => guardarTablet()} />
        </React.Fragment>
    );

    const removerTableta = (rowData) => {
        let _dataRegistro = dataRegistro.filter(val => val.index !== rowData.index);
        setDataRegistro(_dataRegistro)
    }

    const bodyTemplate = (rowData) => {
        return <Button icon="pi pi-trash" rounded onClick={() => removerTableta(rowData)} />
    }

    const onHideDialog = () => {
        setDataRegistro([]);
        onHide();
    }

    const scannerFooterTemplate = () => {
        return(
            <div className="flex justify-content-end">
                <Button className="p-button-outlined" label='Cancelar' icon='pi pi-times' onClick={() => setScannerDialog(!scannerDialog)} />
            </div>
        )
    }

    return (
        <>
            <Dialog visible={visible} breakpoints={{ '641px': '100vw' }} style={{ width: '45%' }} header={tituloModal} modal className="p-fluid" footer={tabletDialogFooter} draggable={false} closable={false} onHide={onHideDialog}>
                <Toast ref={toast} />
                <div className='grid m-3'>
                    <div className='col-12'>
                        <form onSubmit={listarTablet}>
                            <div className='md:flex lg:flex'>
                                <span className='p-float-label w-full md:w-11 lg:w-11'>
                                    <InputText autoFocus id='serie' value={tablet.serie} onChange={(e) => { setTablet({ ...tablet, serie: e.target.value }) }} />
                                    <label htmlFor='serie'>Ingrese serie</label>
                                </span>
                                <Button type="submit" label="Agregar" icon='pi pi-plus' style={{ paddingRight: '20px' }} className="p-button w-full mt-3 md:w-auto lg:w-auto md:ml-3 lg:ml-3 md:mt-0 lg:mt-0" />
                                {parseInt(process.env.REACT_APP_SISTEMA) !== 2 && <Button type="button" label="Escaner" icon='pi pi-qrcode' style={{ paddingRight: '20px' }} className="p-button w-full mt-3 md:w-auto lg:w-auto md:ml-3 lg:ml-3 md:mt-0 lg:mt-0" onClick={() => setScannerDialog(true)} />}
                            </div>
                        </form>
                    </div>
                    {/* <Button className='p-button-outlined w-auto ml-3' label='Limpiar' onClick={() => setTablet(emptyArr)} />
                    <Button className='p-button ml-3 w-auto' label='Aceptar' onClick={() => listarTablet()} /> */}
                </div>
                {/* <Scanner onResult={(e) => { setTablet({ ...tablet, serie: e }) }} />     */}
                <div className='col-12'>
                    <DataTable value={dataRegistro} sortField='index' sortOrder={-1}
                        paginator rows={20} paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate={`Mostrando del {first} al {last} de {totalRecords} ${LABELTEXT.toLowerCase()}.`} emptyMessage={`Sin ${LABELTEXT.toLowerCase()} registradas.`}>
                        <Column field='index' header='Índice' />
                        <Column field='serie' header='Serie' />
                        <Column header='Remover' body={bodyTemplate} bodyStyle={{ textAlign: 'center' }} />
                    </DataTable>
                </div>
            </Dialog>
            <Dialog header='ESCANER' visible={scannerDialog} style={{ width: "40%" }} closable={false} draggable={false} footer={scannerFooterTemplate} >
                <ScannerEntrega alumnoRow={{ IdAlumno: -1 }} onResult={(e) => { listarTabletQR(e.Serie) }} onHide={() => setScannerDialog(!scannerDialog)} />
            </Dialog>
        </>
    )
}

export default RegistrarTableta;